import { Tag } from "features/shared/types/tag";
import Fuse from "fuse.js";

export const searchArrayOfTags = (searchValue: string, tags: Array<Tag>) => {
    const fuse = new Fuse(tags, {
        threshold: 0.2,
        keys: ["key", "value.name.en", "value.name.th", "value.value"],
    });
    const results = fuse.search(searchValue).map((result) => result.item);
    return results as Array<Tag>;
};
